import { ArrowUpRight } from "lucide-react";
import { Nav, NavA, LINKS } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/Motion";
import { PRODUCTS } from "@/components/site/Products";
import { usePageMeta } from "@/lib/pageMeta";
import { useT } from "@/i18n";

const navLabel = (t, [label, id]) => t(`nav.${id.slice(1)}`, label);

const Group = ({ id, title, items, delay }) => (
  <Reveal delay={delay} className="min-w-0" data-testid={`sitemap-group-${id}`}>
    <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-[#8A4B22]">{title}</h2>
    <ul className="mt-5 divide-y divide-[#D8D2C6] border-y border-[#D8D2C6]">
      {items.map(([label, to]) => (
        <li key={to}>
          <NavA to={to} className="group flex items-center justify-between gap-4 py-3 text-base transition-colors duration-300 hover:text-[#C26D38]" data-testid={`sitemap-link-${to.replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "") || "home"}`}>
            {label}
            <ArrowUpRight className="h-4 w-4 shrink-0 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </NavA>
        </li>
      ))}
    </ul>
  </Reveal>
);

export default function MappaSito() {
  const t = useT();
  usePageMeta({
    title: t("map.title", "Mappa del sito"),
    desc: t("map.metaDesc", "Tutte le pagine del sito EMMA INDUSTRIE: legno lamellare, pannelli X-LAM, case in legno, progetti, prodotti, schede tecniche, biomassa e contatti."),
    path: "/mappa-del-sito",
  });
  const pages = [[t("map.home", "Home"), "/"], ...LINKS.filter(([, id]) => id.startsWith("/")).map((l) => [navLabel(t, l), l[1]]), [t("footer.careers", "Lavora con noi"), "/lavora-con-noi"], [t("footer.privacy", "Privacy policy"), "/privacy-policy"], [t("ck.policy", "Cookie policy"), "/cookie-policy"], [t("footer.terms", "Termini e condizioni"), "/termini-e-condizioni"]];
  const sections = [...LINKS.filter(([, id]) => id.startsWith("#")).map((l) => [navLabel(t, l), `/${l[1]}`]), [t("map.docs", "Schede tecniche e catalogo PDF"), "/#schede"]];
  const products = PRODUCTS.map((p) => [t(`prod.${p.id}.code`, p.code), `/?prodotto=${p.id}#prodotti`]);
  return (
    <div className="bg-[#F7F5F0] text-[#121110]" data-testid="sitemap-page">
      <Nav />
      <main className="px-5 pb-24 pt-44 sm:px-8 lg:pb-32 lg:pt-52">
        <div className="mx-auto max-w-[1500px]">
          <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl" data-testid="sitemap-title">{t("map.title", "Mappa del sito")}</h1>
          <p className="mt-5 max-w-2xl text-sm text-[#5A544C] sm:text-base">{t("map.intro", "Tutte le pagine e le sezioni del sito in un solo elenco.")}</p>
          <div className="mt-16 grid gap-14 md:grid-cols-2 lg:grid-cols-3">
            <Group id="pages" title={t("map.pages", "Pagine")} items={pages} />
            <Group id="sections" title={t("map.sections", "Sezioni della home")} items={sections} delay={0.08} />
            <Group id="products" title={t("map.products", "Prodotti")} items={products} delay={0.16} />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
